module.exports = __webpack_public_path__ + "static/img/home-04.976f00d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/home-04.jpg
// module id = aXL2
// module chunks = 1